const { getElement, viewportSize } = window.BAO.Utils
class LazyVideo extends window.BAO.CustomElement() {
  static get styles () {
    return `
      :host {
        display: contents;

        opacity: 0;

        transition: opacity 0.5s ease;
      }
      :host([loaded]) {
        opacity: 1;
      }
    `
  }

  connectedCallback () {
    super.connectedCallback()

    this.video = getElement('video', { context: this })

    if (this.video === null) return

    // eslint-disable-next-line compat/compat
    this.observer = new IntersectionObserver(this.onEntry.bind(this), {
      threshold: 0,
    })
    // We need to observe the video element as the host element has display: contents on it. IntersectionObserver won't work on an element that is set to display: contents
    this.observer.observe(this.video)
  }

  onEntry ([entry], observer) {
    if (!entry.isIntersecting) return

    if (this.video.dataset?.poster) {
      this.video.setAttribute('poster', this.video.dataset.poster)
    }

    for (const source in this.video.children) {
      const videoSource = this.video.children[source]

      if (
        typeof videoSource.tagName === 'string' &&
        videoSource.tagName === 'SOURCE'
      ) {
        videoSource.src = videoSource.dataset.src
      }
    }

    this.video.load()
    observer.unobserve(this.video)

    this.setAttribute('loaded', '')

    if (this.hasAttribute('data-controls')) {
      return this.setupControls()
    }

    if (
      viewportSize() !== `xs` ||
      this.video.hasAttribute('autoplay') === false
    ) {
      return
    }

    if (this.video.paused) {
      document.addEventListener('touchstart', () => {
        if (this.video.paused && !window.sessionStorage.getItem('pauseVideo')) {
          this.video.play()
        }
      })
    }
  }

  setupControls () {
    this.handlePlayClick = this.handlePlayClick.bind(this)
    this.handleAudioClick = this.handleAudioClick.bind(this)
    this.handleProgressBarClick = this.handleProgressBarClick.bind(this)
    this.trackVideoProgress = this.trackVideoProgress.bind(this)

    if (this.els?.play?.exists) {
      this.listeners.add(this.els.play.element, 'click', this.handlePlayClick)
      this.listeners.add(this.video, 'click', this.handlePlayClick)
    }
    if (this.els?.audio?.exists) {
      this.listeners.add(this.els.audio.element, 'click', this.handleAudioClick)
    }
    if (this.els?.progress?.exists) {
      this.listeners.add(
        this.els.progress.element,
        'click',
        this.handleProgressBarClick,
      )
    }

    if (this.video?.hasAttribute('autoplay') && this.els?.bar?.exists) {
      this.trackVideoProgress()
    }
  }

  handlePlayClick () {
    if (this.video.paused) {
      this.video.play()

      this.els.play.element.innerHTML = window.videoStrings.pause

      if (this.els?.bar?.exists) {
        this.trackVideoProgress()
      }
    } else {
      this.video.pause()

      this.els.play.element.innerHTML = window.videoStrings.play

      cancelAnimationFrame(this.animationId)
    }
  }

  handleAudioClick () {
    this.video.muted = !this.video.muted

    this.els.audio.element.innerHTML = this.video.muted
      ? window.videoStrings.unmute
      : window.videoStrings.mute
  }

  handleProgressBarClick (e) {
    const num =
      e.clientX - this.els.progress.element.getBoundingClientRect().left
    const duration = this.video.duration

    this.els.bar.element.style.flexBasis = `${(num * 100) /
      this.els.progress.element.offsetWidth}%`
    this.video.currentTime =
      (duration * num) / this.els.progress.element.offsetWidth
  }

  trackVideoProgress () {
    const duration = this.video.duration

    this.els.bar.element.style.flexBasis = `${(this.video.currentTime /
      duration) *
      100}%`

    this.animationId = requestAnimationFrame(this.trackVideoProgress)
  }
}

if (!customElements.get('lazy-video')) {
  customElements.define('lazy-video', LazyVideo)
}
